/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListTodosRequest} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/list-todos.pb'
import {ListTodosResponse} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/list-todos.pb'


export const listTodos = (request: ListTodosRequest, options?: CashRequestOptions) => post<ListTodosRequest, ListTodosResponse>("/2.0/cash/list-todos", request, {...options, rejectOnError: true })